import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
	name: 'translateArray',
	standalone: true,
	pure: false,
})
export class TranslateArrayPipe implements PipeTransform {
	constructor(private translate: TranslateService) {}

	transform<T extends object = object>(value: T[], key: keyof T): T[] {
		if (!value || !key) {
			return value;
		}
		return value.map(item => {
			const translatedItem = {...item};
			if (translatedItem[key]) {
				translatedItem[key] = this.translate.instant(translatedItem[key] as string);
			}
			return translatedItem;
		});
	}
}
